import { TemplateDataField } from '../../../enums';

/**
 * Maps template data field IDs to appropriate HTML autocomplete attribute values
 * Based on HTML Living Standard autocomplete tokens: https://html.spec.whatwg.org/multipage/forms.html#autofill
 */
// eslint-disable-next-line max-lines-per-function
export function getAutocompleteValueForTemplateDataField(templateDataFieldId: number): string | null {
	switch (templateDataFieldId) {
		// Personal Info Fields - Name
		case TemplateDataField.PersonalSuffix:
			return 'honorific-suffix';
		case TemplateDataField.PersonalPrefix:
			return 'honorific-prefix';
		case TemplateDataField.PersonalFirstName:
			return 'given-name';
		case TemplateDataField.PersonalLastName:
			return 'family-name';
		case TemplateDataField.PersonalMiddleName:
			return 'additional-name';
		case TemplateDataField.PersonalPreferredName:
			return 'nickname';
		case TemplateDataField.PersonalDateOfBirth:
			return 'bday';

		// Email Fields
		case TemplateDataField.PersonalEmail:
		case TemplateDataField.BusinessEmail:
			return 'email';

		// Phone Fields
		case TemplateDataField.PersonalPhoneNumber:
		case TemplateDataField.PhoneNumber:
		case TemplateDataField.BusinessPhone:
			return 'tel-national';

		// Organization Names
		case TemplateDataField.BusinessName:
		case TemplateDataField.FarmName:
			return 'organization';

		// Security Fields
		case TemplateDataField.PersonalSSN:
			return 'off'; // SSN should not be autocompleted for security

		// Personal Address Fields
		case TemplateDataField.PersonalStreetAddress:
			return 'address-line1';
		case TemplateDataField.PersonalStreetAddress2:
			return 'address-line2';
		case TemplateDataField.PersonalCity:
			return 'address-level2';
		case TemplateDataField.PersonalState:
			return 'address-level1';
		case TemplateDataField.PersonalZipCode:
			return 'postal-code';
		case TemplateDataField.PersonalCountry:
			return 'country';

		// Personal Mailing Address Fields
		case TemplateDataField.PersonalMailingStreetAddress:
			return 'address-line1';
		case TemplateDataField.PersonalMailingStreetAddress2:
			return 'address-line2';
		case TemplateDataField.PersonalMailingCity:
			return 'address-level2';
		case TemplateDataField.PersonalMailingState:
			return 'address-level1';
		case TemplateDataField.PersonalMailingZipCode:
			return 'postal-code';

		// Business Address Fields
		case TemplateDataField.BusinessAddress1:
			return 'address-line1';
		case TemplateDataField.BusinessAddress2:
			return 'address-line2';
		case TemplateDataField.BusinessCity:
			return 'address-level2';
		case TemplateDataField.BusinessState:
			return 'address-level1';
		case TemplateDataField.BusinessZipCode:
			return 'postal-code';

		// Business Mailing Address Fields
		case TemplateDataField.BusinessMailingStreetAddress:
			return 'address-line1';
		case TemplateDataField.BusinessMailingStreetAddress2:
			return 'address-line2';
		case TemplateDataField.BusinessMailingCity:
			return 'address-level2';
		case TemplateDataField.BusinessMailingState:
			return 'address-level1';
		case TemplateDataField.BusinessMailingZipCode:
			return 'postal-code';

		// Farm Address Fields
		case TemplateDataField.FarmAddress1:
			return 'address-line1';
		case TemplateDataField.FarmAddress2:
			return 'address-line2';
		case TemplateDataField.FarmCity:
			return 'address-level2';
		case TemplateDataField.FarmState:
			return 'address-level1';
		case TemplateDataField.FarmZipCode:
			return 'postal-code';

		// Farm Mailing Address Fields
		case TemplateDataField.FarmMailingStreetAddress:
			return 'address-line1';
		case TemplateDataField.FarmMailingStreetAddress2:
			return 'address-line2';
		case TemplateDataField.FarmMailingCity:
			return 'address-level2';
		case TemplateDataField.FarmMailingState:
			return 'address-level1';
		case TemplateDataField.FarmMailingZipCode:
			return 'postal-code';

		default:
			return null;
	}
}

/**
 * Gets autocomplete attribute for a component based on its template data field ID
 * Returns null if no autocomplete should be applied
 */
export function getAutocompleteForComponent(component: any): string | null {
	if (!component?.templateDataFieldId) {
		return null;
	}
	return getAutocompleteValueForTemplateDataField(component.templateDataFieldId);
}
